import { GeoJson } from '@ais-ui/api-spec/shapes';

import { useShapesEdit } from '@ais-ui/api';
import { SaveShapeDialog } from './SaveShapeDialog';
import { Dispatch, SetStateAction, useMemo } from 'react';
import { DrawGeometryType } from '@ais-ui/react-openlayers';

interface EditShapeProps {
  setShowDialog: Dispatch<SetStateAction<boolean>>;
  shape: GeoJson;
}

export function EditShape({ setShowDialog, shape }: EditShapeProps) {
  const { mutate } = useShapesEdit();

  const geometryType = useMemo(() => {
    if (shape?.geometry?.type === 'Point' && shape.properties?.radius) {
      return 'Circle';
    }

    return shape?.geometry?.type as DrawGeometryType;
  }, [shape]);

  return (
    <SaveShapeDialog
      setShowOuterDialog={setShowDialog}
      mutate={mutate}
      action="edit"
      geometryType={geometryType}
      shape={shape}
      startInDrawMode={false}
    />
  );
}
